// Fallback avatar used when a user's image fails to load
// Using a reliable placeholder service to ensure availability
export const DEFAULT_AVATAR_URL = 'https://placehold.co/200x200?text=Avatar';
